import './javascript/countries' ; 
import './javascript/darkmode';
import './javascript/menu';
import './javascript/details';